import { render, staticRenderFns } from "./ShipmentData.vue?vue&type=template&id=9eacd026&"
import script from "./ShipmentData.vue?vue&type=script&lang=js&"
export * from "./ShipmentData.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports